export interface SummarizeSettings {
  labelKey: string;
  valueKey: string;
  limit?: number;
}

export const summarize = <T extends Record<string, any>>(
  list: T[],
  settings: SummarizeSettings
) => {
  const limit = (settings.limit || 10) - 1;
  const { labelKey, valueKey } = settings;
  const top10 = list.length <= limit ? list : list.slice(0, limit);
  const others = list.length <= limit ? [] : list.slice(limit);
  if (others.length > 0) {
    // Ensure values are numeric for summing
    const numericValues = others.map(item =>
      typeof item[valueKey as keyof T] === 'number' ? (item[valueKey as keyof T] as number) : 0
    );
    const otherEntry = {
      [labelKey]: 'Other',
      [valueKey]: numericValues.reduce((sum, value) => sum + value, 0),
    };
    return [...top10, otherEntry];
  }

  return top10;
};
